import NoColumns from "./no-columns";

export default NoColumns;
